import { request } from '@/utils/request'
import { getBaseUrlStore, getParameter } from '@/utils/endpoint'

export function getProduct(params = {}) {
  const new_params = { ...getParameter(), ...params }
  return request.get(getBaseUrlStore() + '/product', { params: new_params })
}

export function getProductDetail(id, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return request.get(getBaseUrlStore() + '/product/' + id, {
    params: new_params
  })
}

export function getProductGroup(params = {}) {
  const new_params = { ...getParameter(), ...params }
  return request.get(getBaseUrlStore() + '/productgroup', {
    params: new_params
  })
}

export function getProductCombo(params = {}) {
  const new_params = { ...getParameter(), ...params }
  return request.get(getBaseUrlStore() + '/productcombo', {
    params: new_params
  })
}

export function getProductComboDetail(id, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return request.get(getBaseUrlStore() + '/productcombo/' + id, {
    params: new_params
  })
}

export function getProductRelated(id, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return request.get(getBaseUrlStore() + '/product/' + id + '/related', {
    params: new_params
  })
}

export function getSearchListAllProduct(params = {}) {
  const new_params = { ...getParameter(), ...params }
  return request.get(getBaseUrlStore() + '/item/search', {
    params: new_params
  })
}
